/**
 * Chatbot Module Constants
 * Centralized constants for chatbot module strings and default values.
 */

import type { SuggestedQuestion } from '../types';

/**
 * Chatbot UI strings.
 */
export const CHATBOT_STRINGS = {
  PAGE_TITLE: 'AI Assistant',
  PAGE_SUBTITLE: 'Get instant answers to your questions',
  SYSTEM_NAME: "Sistem Dai'e Chatbot",
  STATUS_ONLINE: 'Online',
  COMMON_QUESTIONS_TITLE: 'Common Questions',
  INPUT_PLACEHOLDER: 'Type your message...',
  WELCOME_MESSAGE: "Hello! I am the Sistem Dai'e AI Assistant. How can I help you today?",
  ARIA_CHAT_MESSAGES: 'Chat messages',
  ARIA_MESSAGE_INPUT: 'Message input',
  ARIA_SEND_MESSAGE: 'Send message',
  ARIA_OPEN_CHATBOT: 'Open chatbot',
  ARIA_CLOSE_CHATBOT: 'Close chatbot',
} as const;

/**
 * Default suggested questions for the chatbot.
 */
export const DEFAULT_SUGGESTED_QUESTIONS: SuggestedQuestion[] = [
  { id: '1', label: 'Product information', category: 'product' },
  { id: '2', label: 'Sales SOP', category: 'sop' },
  { id: '3', label: 'Legal compliance', category: 'legal' },
  { id: '4', label: 'Training resources', category: 'training' },
];

